import { render, staticRenderFns } from "./unqualifiedDestructionAction.vue?vue&type=template&id=6a0971e0&scoped=true"
import script from "./unqualifiedDestructionAction.vue?vue&type=script&lang=js"
export * from "./unqualifiedDestructionAction.vue?vue&type=script&lang=js"
import style0 from "./unqualifiedDestructionAction.vue?vue&type=style&index=0&id=6a0971e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a0971e0",
  null
  
)

export default component.exports